import type { Bid } from '../../types/Bid'
import { BID_TYPES } from '@autobid/ui/constants/BID_TYPES'

export function getUsersBids(bids: Bid[]) {
  return bids.filter(bid => bid.type === BID_TYPES.USER_BID)
}
